import { render, staticRenderFns } from "./CreateInteraction.vue?vue&type=template&id=52714733&scoped=true&"
import script from "./CreateInteraction.vue?vue&type=script&lang=js&"
export * from "./CreateInteraction.vue?vue&type=script&lang=js&"
import style0 from "./CreateInteraction.vue?vue&type=style&index=0&id=52714733&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52714733",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDatePicker,VSelect})
